import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailNamePipe } from './emailNamePipe';
import { TimeAgoPipe } from './time-ago.pipe';


@NgModule({
  declarations: [
  EmailNamePipe,
  TimeAgoPipe,
  ],
  imports: [
  CommonModule,
  ],
  exports: [
  EmailNamePipe,
  TimeAgoPipe,
  ],
  })
export class PipesModule {
}
